import React from 'react'
import { useMemo } from 'sb-hooks'

import { Box, Row } from 'components/_new/layout'
import { Image, Ribbon } from 'components/_new/ui'
import Text from 'components/_new/typography/Text/Text'
import Rating from 'components/_new/product/Rating/Rating'

import messages from './messages'
import s from './ProductOffer.scss'


type ProductOfferProps = {
  product: GiftOfferModal.ProductType
}


const ProductOffer: React.FunctionComponent<ProductOfferProps> = ({ product }) => {
  const { name, brand, image, rating } = product

  const offerProduct = useMemo(() => ({
    ...messages.offerProduct, values: { brand, name },
  }), [ brand, name ])

  return (
    <Box
      className={s.container}
      pt={24}
      ph={20}
      pb={32}
    >
      <Text
        className={s.text}
        message={messages.offerText}
        size="16-24"
        color="black"
        align="center"
      />
      <Box pt={32} alignCenter>
        <Image className={s.image} src={image} w={180} resizeBy="width" />
        <Ribbon text={messages.ribbonText} offsetTop={8} />
        <Row justify="center">
          <Rating value={rating} />
        </Row>
        <Box pt={16}>
          <Text
            message={offerProduct}
            size="16-24"
            color="black"
            html
          />
        </Box>
      </Box>
    </Box>
  )
}


export default ProductOffer
